module.exports = __webpack_public_path__ + "img/icon_check_white.3713e445.svg";